import React        from 'react';
import { Text }     from '@mantine/core';
import parse        from 'html-react-parser'
import { CSection } from '@core/components/common/CSection';
import useIsMounted from '@hooks/use-is-mounted';


interface Props {
    description: string;
}

export const DescriptionSection: React.FC<Props> = ({ description }) => {

    const isMounted = useIsMounted();


    return isMounted && (
        <CSection
            // className={} to control content div only
            // change heading styling in the component itself.
            heading="About this property"
            content={
                <Text size={12} align="justify">
                    {parse(description || '_')}
                </Text>
            }
        />
    )

}
